"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _factories = require("../factories");
var _components = require("../components");
var _views = require("../views");
var _containers = require("../containers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } /* eslint-disable react/display-name */
var _default = (entity, actions) => {
  let routesObject = {
    overview: {
      path: entity.plural,
      title: entity.title,
      level: 0,
      icon: entity.icon,
      private: true,
      restricted: `control.${entity.plural}`
    }
  };
  if (entity.secondaryMenu.find(el => el === "list")) {
    Object.assign(routesObject, {
      list: {
        path: `${entity.plural}`,
        title: `List ${entity.title}`,
        level: 1,
        icon: "view_list",
        private: true,
        restricted: `control.${entity.plural}`,
        component: props => /*#__PURE__*/_react.default.createElement(_views.Template, {
          title: `List ${entity.title}`
        }, /*#__PURE__*/_react.default.createElement(_containers.BaseList, _extends({}, props, {
          entity: entity,
          actions: actions
        }), /*#__PURE__*/_react.default.createElement(_components.ListFilter, _extends({}, props, {
          entity: entity,
          actions: actions
        })), /*#__PURE__*/_react.default.createElement(_containers.ListTableConnector, null, /*#__PURE__*/_react.default.createElement(_components.TablePagination, null, /*#__PURE__*/_react.default.createElement(_components.Table, _extends({}, props, {
          entity: entity,
          actions: actions
        }))))))
      }
    });
  }
  if (entity.secondaryMenu.find(el => el === "create_translations")) {
    Object.assign(routesObject, {
      create_translations: {
        path: `${entity.plural}/create`,
        title: `Create Text`,
        level: 1,
        icon: "add_box",
        private: true,
        restricted: `control.${entity.plural}/create`,
        component: props => /*#__PURE__*/_react.default.createElement(_views.Template, {
          title: `Create ${entity.title}`
        }, /*#__PURE__*/_react.default.createElement(_containers.BaseCreate, _extends({}, props, {
          entity: entity,
          actions: actions
        }), /*#__PURE__*/_react.default.createElement(_containers.CreateFormConnector, null, /*#__PURE__*/_react.default.createElement(_components.CreateTranslationsTable, {
          actions: actions,
          entity: entity
        }))))
      }
    });
  }
  if (entity.secondaryMenu.find(el => el === "translate")) {
    Object.assign(routesObject, {
      translate: {
        path: `${entity.plural}/translate`,
        title: `Translate Text`,
        icon: "g_translate",
        private: true,
        level: 1,
        restricted: `control.${entity.plural}/translate`,
        component: props => /*#__PURE__*/_react.default.createElement(_views.Template, {
          title: `Translate ${entity.title}`
        }, /*#__PURE__*/_react.default.createElement(_containers.BaseTranslate, {
          entity: entity,
          actions: actions
        }, /*#__PURE__*/_react.default.createElement(_factories.TranslateFactory, _extends({}, props, {
          entity: entity,
          actions: actions
        }))))
      }
    });
  }
  if (entity.secondaryMenu.find(el => el === "upload_media")) {
    Object.assign(routesObject, {
      upload_media: {
        path: `${entity.plural}/upload_media`,
        title: `Upload Media`,
        icon: "publish",
        private: true,
        level: 1,
        restricted: `control.${entity.plural}/upload_media`,
        component: props => /*#__PURE__*/_react.default.createElement(_views.Template, {
          title: `Upload ${entity.title}`
        }, /*#__PURE__*/_react.default.createElement(_containers.BaseUploadMedia, _extends({}, props, {
          entity: entity,
          actions: actions
        }), /*#__PURE__*/_react.default.createElement(_factories.UploadMediaFactory, {
          entity: entity,
          actions: actions
        })))
      }
    });
  }
  if (entity.secondaryMenu.find(el => el === "create")) {
    Object.assign(routesObject, {
      create: {
        path: `${entity.plural}/create`,
        title: `Create ${entity.title}`,
        level: 1,
        icon: "add_box",
        private: true,
        restricted: `control.${entity.plural}/create`,
        component: props => /*#__PURE__*/_react.default.createElement(_views.Template, {
          title: `Create ${entity.title}`
        }, /*#__PURE__*/_react.default.createElement(_containers.BaseCreate, _extends({}, props, {
          entity: entity,
          actions: actions
        }), /*#__PURE__*/_react.default.createElement(_containers.CreateFormConnector, null, /*#__PURE__*/_react.default.createElement(_factories.CreateFormFactory, {
          entity: entity
        }))))
      }
    });
  }
  if (entity.secondaryMenu.find(el => el === "create_languages")) {
    Object.assign(routesObject, {
      create: {
        path: `${entity.plural}/create`,
        title: `Create ${entity.title}`,
        level: 1,
        icon: "add_box",
        private: true,
        restricted: `control.${entity.plural}/create`,
        component: props => /*#__PURE__*/_react.default.createElement(_views.Template, {
          title: `Create ${entity.title}`
        }, /*#__PURE__*/_react.default.createElement(_containers.BaseCreate, _extends({}, props, {
          entity: entity,
          actions: actions
        }), /*#__PURE__*/_react.default.createElement(_containers.CreateFormConnector, null, /*#__PURE__*/_react.default.createElement(_components.CreateLanguagesTable, {
          actions: actions,
          entity: entity
        }))))
      }
    });
  }
  if (entity.secondaryMenu.find(el => el === "import")) {
    Object.assign(routesObject, {
      import: {
        path: `${entity.plural}/import`,
        title: `Import ${entity.title}`,
        icon: "library_add",
        private: true,
        level: 1,
        restricted: `control.${entity.plural}/import`,
        component: () => /*#__PURE__*/_react.default.createElement(_views.Template, {
          title: `Import ${entity.title}`
        }, /*#__PURE__*/_react.default.createElement(_containers.BaseImport, {
          entity: entity,
          actions: actions
        }, /*#__PURE__*/_react.default.createElement(_factories.ImportFactory, {
          entity: entity,
          actions: actions
        })))
      }
    });
  }
  if (entity.secondaryMenu.find(el => el === "import_translations")) {
    Object.assign(routesObject, {
      import: {
        path: `${entity.plural}/import`,
        title: `Import ${entity.title}`,
        icon: "library_add",
        private: true,
        level: 1,
        restricted: `control.${entity.plural}/import`,
        component: () => /*#__PURE__*/_react.default.createElement(_views.Template, {
          title: `Import ${entity.title}`
        }, /*#__PURE__*/_react.default.createElement(_containers.BaseImportTranslations, {
          entity: entity,
          actions: actions
        }, /*#__PURE__*/_react.default.createElement(_factories.ImportFactory, {
          entity: entity,
          actions: actions,
          importTranslation: true
        })))
      }
    });
  }
  if (entity.secondaryMenu.find(el => el === "single")) {
    Object.assign(routesObject, {
      single: {
        path: `${entity.plural}/:${entity.singular}`,
        title: `Show ${entity.title}`,
        private: true,
        restricted: `control.${entity.plural}`,
        component: props => /*#__PURE__*/_react.default.createElement(_containers.BaseShow, _extends({}, props, {
          entity: entity,
          actions: actions
        }), /*#__PURE__*/_react.default.createElement(_views.Template, _extends({}, props, {
          title: entity.singleTitle || `Show ${entity.title}`,
          singular: props.match.params[entity.singular],
          link: {
            to: props => props[entity.singular].fetched ? `/${entity.plural}/${props[entity.singular].data.Id}/edit` : null,
            text: "Edit"
          }
        }), /*#__PURE__*/_react.default.createElement(_factories.DetailFactory, {
          entity: entity,
          singular: props.match.params[entity.singular]
        })))
      }
    });
  }
  if (entity.secondaryMenu.find(el => el === "edit")) {
    Object.assign(routesObject, {
      edit: {
        path: `${entity.plural}/:${entity.singular}/edit`,
        title: `Edit ${entity.title}`,
        icon: "assignment_ind",
        private: true,
        restricted: `control.${entity.plural}`,
        component: props => /*#__PURE__*/_react.default.createElement(_containers.BaseShow, _extends({}, props, {
          entity: entity,
          actions: actions
        }), /*#__PURE__*/_react.default.createElement(_views.Template, {
          title: entity.singleTitle || `Edit ${entity.title}`,
          link: {
            to: props => props[entity.singular].fetched ? `/${entity.plural}/${props[entity.singular].data.Id}` : null,
            text: "Cancel"
          }
        }, /*#__PURE__*/_react.default.createElement(_containers.BaseEdit, {
          entity: entity,
          actions: actions
        }, /*#__PURE__*/_react.default.createElement(_factories.EditFormFactory, {
          entity: entity
        }))))
      }
    });
  }
  return routesObject;
};
exports.default = _default;
module.exports = exports.default;